import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Fieldset, Legend, Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input,
    Collapse
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import Select from '../../../../../helpers/ui/CustomSelect'
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect, withRouter } from "react-router-dom"


class DetailModal extends Component {

    // indexBloc = new IndexBloc()
    timer
    source
    defaultSize = 10

    constructor(props) {
        super(props)
        this.state = {
            dataForm: null,
            optionSignatureOfficer: [
                { label: "Kepala Biro Umum", value: "Kepala Biro Umum" },
                { label: "Sekretariat Utama", value: "Sekretariat Utama" },
                { label: "Atas Nama", value: "Atas Nama" }
            ],
        }
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }


    setTokenAPI = () => {
        // if (typeof this.source != typeof undefined) {
        //     this.source.cancel();
        // }
        // this.source = cancelToken()
    }

    componentDidMount() {
        
    }

    componentWillUnmount() {
        // indexBloc.updateSpmjChannel?.unsubscribe();
    }

    componentDidUpdate(prevProps, prevState) {
    }

    render() {
        return (
            <Fragment>
                <Modal isOpen={this.props.modal} size='lg' toggle={this.props.toggle}>
                    <AvForm
                        className="needs-validation"
                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                    >
                        <ModalHeader toggle={this.props.toggle}>Detail Mapping Masa Kerja</ModalHeader>
                        <ModalBody>

                            <dl class="row mb-0">
                                <dt class="col-sm-3">Jenis Mutasi</dt>
                                <dd class="col-sm-9">{this.props.employee_transfer_mutasi_jenis}</dd>
                                
                                <dt class="col-sm-3">Nomor SK</dt>
                                <dd class="col-sm-9">{this.props.employee_transfer_detail_decree_number}</dd>
                                
                                <dt class="col-sm-3">Tanggal SK</dt>
                                <dd class="col-sm-9">{new Date(this.props.employee_transfer_detail_decree_date).toLocaleDateString('id-ID', { day: '2-digit', month: '2-digit', year: 'numeric' })}</dd>
                                
                                <dt class="col-sm-3">TMT</dt>
                                <dd class="col-sm-9">{new Date(this.props.employee_transfer_detail_tmt_date).toLocaleDateString('id-ID', { day: '2-digit', month: '2-digit', year: 'numeric' })}</dd>
                                
                                <dt class="col-sm-3">NIP</dt>
                                <dd class="col-sm-9">{this.props.nip}</dd>

                                <dt class="col-sm-3">Nama</dt>
                                <dd class="col-sm-9">{this.props.nama}</dd>
                                
                                <dt class="col-sm-3">Pangkat</dt>
                                <dd class="col-sm-9">{this.props.rank_group_room}</dd>
                                
                                <dt class="col-sm-3">Unit kerja Lama</dt>
                                <dd class="col-sm-9">{this.props.employee_transfer_detail_old_work_unit_name}</dd>
                                
                                <dt class="col-sm-3">Jabatan Lama</dt>
                                <dd class="col-sm-9">{this.props.employee_transfer_detail_old_position_name}</dd>
                                
                                <dt class="col-sm-3">Unit kerja Baru</dt>
                                <dd class="col-sm-9">{this.props.employee_transfer_detail_work_unit_name}</dd>

                                <dt class="col-sm-3">Jabatan Baru</dt>
                                <dd class="col-sm-9">{this.props.employee_transfer_detail_position_name}</dd>
                            
                                <dt class="col-sm-3">Pegawai Pengganti</dt>
                                <dd class="col-sm-9">{this.props.employee_transfer_detail_replacement_name}</dd>
                            
                            
                            </dl>
                            
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>{' '}
                        </ModalFooter>
                    </AvForm>

                </Modal>

            </Fragment>
        )
    }
}

export default withRouter(DetailModal)